export const policiesProceduresConstants = {
    TAB: 'Tab',
    ARTICLE: 'Article',
    POLICIES_PROCEDURES_MANUAL: 'YPO Policies and Procedures Manual',
    NO_DATA_FOUND: 'No Data Found',
    POLICIES_PROCEDURES: 'Policies and Procedures -',
    REVISED_DATE: 'Revised Date',
    YPO_BYLAWS: 'YPO Bylaws',
    SLASH: '/',
    NO_RESULT_FOUND: 'No Results Found',
    POLICIES_PROCEDURES_OVERVIEW: 'YPO Policies and Procedures Overview',
};
